import { apiFetch } from "./http";

// Proje — müşterinin kendi org'una bağlı. İsteğe bağlı fatura adresine bağlanır.
export type Project = {
  id: number;
  org_id: number;
  name: string;
  description?: string;
  billing_address_id?: number | null;
  billing_title?: string;
  status: "taslak" | "aktif" | "tamamlandi";
  created_at: string;
};

export type ProjectInput = {
  name: string;
  description?: string;
  billing_address_id?: number | null;
  status?: "taslak" | "aktif" | "tamamlandi";
};

async function errText(res: Response): Promise<string> {
  let msg = `HTTP ${res.status}`;
  try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
  return msg;
}

export async function listProjects(): Promise<Project[]> {
  const res = await apiFetch("/api/v1/projects");
  if (!res.ok) throw new Error(`listProjects: HTTP ${res.status}`);
  const data = (await res.json()) as { projects: Project[] | null };
  return data.projects ?? [];
}

export async function createProject(input: ProjectInput): Promise<Project> {
  const res = await apiFetch("/api/v1/projects", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(await errText(res));
  return res.json();
}

export async function deleteProject(id: number): Promise<void> {
  const res = await apiFetch(`/api/v1/projects/${id}`, { method: "DELETE" });
  if (!res.ok && res.status !== 404) throw new Error(`deleteProject: HTTP ${res.status}`);
}
